<template>
<v-container>
<!--(팝업)기업 정보-->
    <v-dialog
      v-model="companydialog" @keydown.esc="companydialog = false"
      max-width="400px"
      persistent>
      <v-card id="popStyle03">
        <!--팝업 제목-->
        <v-card-title class="title">
          기업 정보
          <v-btn fab class="popBtnClose" @click="companydialog = false"></v-btn>
        </v-card-title>
        <!--/팝업 제목-->
        <!--팝업 내용-->
        <v-card-text>
          <v-row no-gutters class="justify-center popCon">
                <v-col cols="12" class="pd-0">
                  <div class="txtst_info_gray row_mb-20">* 사업자등록번호는 변경할 수 없습니다.</div>
                </v-col>
                <v-col cols="12" class="pd-0">
                  <v-text-field class="inputH48_01 row_mb-8"
                    label="사업자등록번호"
                    v-model="orgInfo.organizationRegistrationNumber"
                    outlined
                    disabled
                  >
                  </v-text-field>
                </v-col>
                <v-col cols="12" class="popCon_input_W100_cov pd-0">
                  <v-text-field class="inputH48_01 conBstar row_mb-8"
                    label="기업명"
                    ref="organizationRequireRules"
                    v-model="orgInfo.organizationName"
                    :rules="rules.organizationRequireRules"
                    maxlength="1000"
                    outlined
                  >
                  </v-text-field>
                  <v-text-field class="inputH48_01 conBstar row_mb-8"
                    label="대표자"
                    ref="presidentName"
                    v-model="orgInfo.presidentName"
                    :rules="rules.nameRequireRules"
                    maxlength="100"
                    outlined
                  >
                  </v-text-field>
                  <v-text-field class="inputH48_01 W100 conBstar row_mb-8"
                    label="주소"
                    ref="organizationAddress"
                    v-model="orgInfo.organizationAddress"
                    :rules="rules.addressRequireRules"
                    maxlength="2000"
                    outlined
                  >
                  </v-text-field>
              <v-text-field class="inputH48_01"
                    label="연락처"
                    ref="organizationContactRules"
                    v-model="orgInfo.organizationContact"
                    :rules="rules.organizationContactRules"
                    maxlength="100"
                    outlined
                  >
                  </v-text-field>
                </v-col>
          </v-row>
        </v-card-text>
        <!--/팝업 내용-->
        <!--팝업 버튼-->
        <v-card-actions class="justify-center">
          <!--회원탈퇴 tab 누를시만 버튼 네임 변경-->
          <v-btn class="btn_C01" text @click="editOrginfoSubmit()" >수정</v-btn>
          <v-btn text @click="companydialog = false">취소</v-btn>
        </v-card-actions>
        <!--/팝업 버튼-->
      </v-card>
    </v-dialog>
    <!--/(팝업)기업 정보-->
    <s-loading ref="loading"></s-loading>
    <s-confirm ref="confirm"></s-confirm>
  </v-container>
</template>

<script>

import { updateOrgInfo }  from '@/api/orgconfig'

export default {
  name: 'company',
  components: {
  },
  props:{
    focusOrgInfo: {}
  },
  filters: {
    
  },
  data () {
    return {
      companydialog: false,
      orgInfo: {
        organizationName: '',
        creationDatetimesubstr: '',
        organizationRegistrationNumber: '',
        presidentName: '',
        organizationAddress: '',
        organizationContact: '',
        organizationSequence: '',
        chainAddress: ''
      },
      formOrg: {
        organizationName: '',
        organizationRegistrationNumber: '',
        presidentName: '',
        organizationAddress: '',
        organizationContact: '',
        promotionCode: ''
      },
      formOrgBc: {
        password: '',
        password_re: ''
      },
      // 프로모션코드 체크 여부
      isPromotionCode: false,
      // 기업 참여 요청 팝업
      orginfoGroupReqVisible: false,
      // 기업 정보 수정 팝업
      orginfoEditVisible: false,
      // 기업정보 등록 팝업
      orginfoCreateVisible: false,
      rules: {
				organizationRequireRules: [
					v => !!v || '기업명을 입력해주세요.'
        ],
        orgRegnoRequireRules:[
					v => !!v || '사업자번호를 입력해주세요.',
					v => (v && v.length === 10) || '사업자등록번호는 10자리입니다.',
					v => /^[0-9]*$/.test(v) || '숫자만 입력해주세요.'
				],
				nameRequireRules:[
          v => !!v || '대표자명을 입력하세요.',
				],
				addressRequireRules: [
					v => !!v || '주소지를 입력해주세요.',
        ],
      }
    }
  },
  created () {
  },
  mounted () {
  },  
  methods: {
    open() {
      this.companydialog = true
      this.orgInfo = this.focusOrgInfo
    },
    editOrginfoSubmit () {
      if (this.$refs.organizationRequireRules.validate() && this.$refs.presidentName.validate() && this.$refs.organizationAddress.validate() && this.$refs.organizationContactRules.validate()) {
        this.$refs.loading.start('입력 정보 확인 중')
        updateOrgInfo(this.orgInfo).then(Response => {
          this.$refs.loading.end()
          if (Response.rdata !== undefined && Response.rdata.rcode === 20000) {
            this.initDialog()
            this.$refs.confirm.open('alert', '기업정보 변경', '정보 수정 완료')
            this.companydialog = false
          } else {
            var msg = ''
            if (Response.rdata === undefined) {
              msg = Response.message
            } else {
              msg = Response.rdata.message
            }
            this.$refs.confirm.open('alert', '기업정보 변경', msg)
          }
        })
      }
    },
    initDialog () {
      this.formOrg.organizationName = ''
      this.formOrg.organizationRegistrationNumber = ''
      this.formOrg.presidentName = ''
      this.formOrg.organizationAddress = ''
      this.formOrg.organizationContact = ''
      this.formOrg.organizationEmail = ''
      this.formOrg.promotionCode = ''
      this.formOrgBc.password = ''
      this.formOrgBc.password_re = ''

      this.isPromotionCode = false // 프로모션 코드 유효성 확인
      this.orginfoGroupReqVisible = false // 참여요청
      this.orginfoEditVisible = false // 기업 정보 수정
      this.orginfoCreateVisible = false // 기업정보 생성
      this.orginfoBCCreateVisible = false // 기업 블록체인 생성

      this.orgBlockChainCompleteVisible = false // 기업 블록체인 생성 완료
      this.orgJoinRequestVisible = false // 기업 인증 요청
      this.orgConfigPage = 1 // 기업신청 안내 화면 전환
    },
  }

}
</script>